import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_2 = { class: "d-flex align-center flex-wrap ga-3" }
const _hoisted_3 = { class: "tp-rule-bar__slot" }
const _hoisted_4 = {
  key: 0,
  class: "tp-rule-bar__value"
}
const _hoisted_5 = {
  key: 0,
  class: "tp-legend tp-legend--carry mr-1"
}
const _hoisted_6 = {
  key: 1,
  class: "tp-rule-bar__placeholder"
}
const _hoisted_7 = {
  key: 2,
  class: "text-caption text-warning mt-1"
}
const _hoisted_8 = { class: "tp-rule-bar__slot" }
const _hoisted_9 = {
  key: 0,
  class: "tp-rule-bar__value"
}
const _hoisted_10 = {
  key: 1,
  class: "tp-rule-bar__placeholder"
}
const _hoisted_11 = { class: "tp-rule-bar__slot" }
const _hoisted_12 = { class: "text-caption text-grey-darken-1 mt-1" }
const _hoisted_13 = {
  key: 1,
  class: "tp-rule-bar__placeholder"
}
const _hoisted_14 = { class: "text-subtitle-2 mb-1" }
const _hoisted_15 = { class: "d-flex align-center mb-1" }
const _hoisted_16 = { class: "text-subtitle-2" }
const _hoisted_17 = { class: "text-caption text-grey-darken-1" }
const _hoisted_18 = { class: "mt-5 d-flex align-center flex-wrap ga-2" }
const _hoisted_19 = { class: "text-subtitle-2" }
const _hoisted_20 = {
  key: 1,
  class: "text-caption text-warning mr-3"
}
const _hoisted_21 = ["onClick", "onMouseenter"]
const _hoisted_22 = {
  key: 0,
  class: "text-caption text-grey"
}
const _hoisted_23 = { class: "text-caption text-grey" }
const _hoisted_24 = { class: "d-flex flex-wrap ga-1" }
const _hoisted_25 = {
  key: 2,
  class: "text-caption text-grey"
}
const _hoisted_26 = { class: "text-right" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  colspan: "6",
  class: "text-center text-grey py-4"
}
const _hoisted_29 = { class: "font-weight-bold" }
const _hoisted_30 = { class: "text-caption mt-1" }
const _hoisted_31 = { class: "font-weight-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_teaching_plan_mini_grid = _resolveComponent("teaching-plan-mini-grid")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "text-subtitle-1" }, "転記ルール", -1)),
    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "text-caption text-grey-darken-1" }, " 上位計画の項目を下位計画に引き継ぐ設定です。転記先のレイアウトごとに設定します。 ", -1)),
    _createVNode(_component_v_row, {
      align: "center",
      class: "mt-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              "model-value": _ctx.pairTargetPlanType,
              items: _ctx.pairItems,
              label: "転記の組み合わせ",
              variant: "outlined",
              density: "compact",
              color: "primary",
              "hide-details": "",
              disabled: _ctx.saving,
              "onUpdate:modelValue": _ctx.onPairChange
            }, null, 8, ["model-value", "items", "disabled", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "7",
          class: "d-flex align-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_spacer),
            (_ctx.targetTemplateId)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  size: "small",
                  variant: "text",
                  color: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-template', _ctx.targetTemplateId)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("mdi-table-edit", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[6] || (_cache[6] = _createTextVNode(" 転記先のレイアウトを編集 ", -1))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : (_ctx.loadFailed)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 1,
            type: "error",
            variant: "tonal",
            density: "compact",
            class: "mt-3"
          }, {
            append: _withCtx(() => [
              _createVNode(_component_v_btn, {
                size: "small",
                variant: "outlined",
                onClick: _ctx.load
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("再読み込み", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            default: _withCtx(() => [
              _cache[8] || (_cache[8] = _createTextVNode(" 転記ルールを読み込めませんでした。通信状況を確認して、もう一度お試しください。 ", -1))
            ]),
            _: 1
          }))
        : (_ctx.targetTemplateId)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (!_ctx.targetLayout)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "info",
                    variant: "tonal",
                    density: "compact",
                    class: "mt-3"
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode(" このレイアウトはまだ公開されていません。公開すると転記ルールを設定できます。 ", -1)
                    ]))]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_v_card, {
                      variant: "outlined",
                      class: "mt-3 pa-3 tp-rule-bar"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-caption text-grey-darken-1" }, "転記元の項目", -1)),
                            (_ctx.barSourceCell)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  (_ctx.showingActiveRule && _ctx.selectedRule)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.selectedRule.symbol), 1))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_ctx.barSourceCell.name), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_6, "左のグリッドから選択")),
                            (_ctx.barSourceKey && _ctx.missingSourceLabel(_ctx.barSourceKey))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.missingSourceLabel(_ctx.barSourceKey)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(_component_v_icon, { color: "grey" }, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                              _createTextVNode("mdi-arrow-right-bold", -1)
                            ]))]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_8, [
                            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-caption text-grey-darken-1" }, "転記先の項目", -1)),
                            (_ctx.barTargetCell)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.barTargetCell.name), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_10, "右のグリッドから選択"))
                          ]),
                          _createVNode(_component_v_divider, { vertical: "" }),
                          _createElementVNode("div", _hoisted_11, [
                            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-caption text-grey-darken-1" }, "種別", -1)),
                            (_ctx.derivedMode)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_v_chip, {
                                    size: "small",
                                    variant: "flat",
                                    color: _ctx.derivedMode === 'reference' ? 'primary' : 'light-blue-lighten-4'
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.transferModeLabels[_ctx.derivedMode]), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["color"]),
                                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.derivedModeHint), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock("div", _hoisted_13, "転記先の型から自動で決まります"))
                          ]),
                          _createVNode(_component_v_spacer),
                          (_ctx.selectedSourceKey || _ctx.selectedTargetKey)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                size: "small",
                                variant: "text",
                                onClick: _ctx.clearSelection
                              }, {
                                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                  _createTextVNode(" 選択を解除 ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.activeRule)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                size: "small",
                                variant: "text",
                                color: "error",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeRule(_ctx.activeRule.targetItemKey)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { start: "" }, {
                                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                      _createTextVNode("mdi-link-variant-off", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.activeRule.symbol) + " の対応を解除 ", 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-caption text-grey-darken-1 mt-2" }, " 転記元と転記先を1つずつ選ぶと対応づきます。記号（A・B・C…）が両側の同じ項目に付きます。 ", -1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { class: "mt-1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_14, " 転記元: " + _toDisplayString(_ctx.planTypeLabels[_ctx.sourcePlanType]), 1),
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.sourceTemplateId,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sourceTemplateId) = $event)),
                              items: _ctx.sourceTemplateItems,
                              label: "転記元のレイアウト",
                              variant: "outlined",
                              density: "compact",
                              color: "primary",
                              "hide-details": "",
                              class: "mb-2",
                              "no-data-text": "公開済みのレイアウトがありません"
                            }, null, 8, ["modelValue", "items"]),
                            _createVNode(_component_teaching_plan_mini_grid, {
                              layout: _ctx.sourceLayout,
                              markers: _ctx.sourceMarkers,
                              "selected-item-key": _ctx.selectedSourceKey,
                              "active-item-key": _ctx.activeSourceKey,
                              "empty-text": "公開済みの上位レイアウトがありません。先に上位の帳票レイアウトを公開してください。",
                              onSelect: _ctx.selectSource
                            }, null, 8, ["layout", "markers", "selected-item-key", "active-item-key", "onSelect"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, " 転記先: " + _toDisplayString(_ctx.planTypeLabels[_ctx.targetPlanType]), 1),
                              _createVNode(_component_v_spacer),
                              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.draftRules.length) + " / " + _toDisplayString(_ctx.targetCells.length) + " 項目に設定済み ", 1)
                            ]),
                            _createVNode(_component_v_select, {
                              "model-value": _ctx.targetTemplateId,
                              items: _ctx.targetTemplateItems,
                              label: "転記先のレイアウト",
                              variant: "outlined",
                              density: "compact",
                              color: "primary",
                              "hide-details": "",
                              class: "mb-2",
                              disabled: _ctx.saving,
                              "no-data-text": "公開済みのレイアウトがありません",
                              "onUpdate:modelValue": _ctx.onTargetTemplateChange
                            }, null, 8, ["model-value", "items", "disabled", "onUpdate:modelValue"]),
                            _createVNode(_component_teaching_plan_mini_grid, {
                              layout: _ctx.targetLayout,
                              markers: _ctx.targetMarkers,
                              "selected-item-key": _ctx.selectedTargetKey,
                              "active-item-key": _ctx.activeTargetKey,
                              "muted-item-keys": _ctx.selectedSourceKey ? _ctx.mappedTargetKeys : [],
                              onSelect: _ctx.selectTarget
                            }, null, 8, ["layout", "markers", "selected-item-key", "active-item-key", "muted-item-keys", "onSelect"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _cache[26] || (_cache[26] = _createStaticVNode("<div class=\"d-flex align-center flex-wrap ga-3 mt-2 text-caption text-grey-darken-1\" data-v-157cf1e4><span class=\"d-inline-flex align-center ga-1\" data-v-157cf1e4><span class=\"tp-legend tp-legend--carry\" data-v-157cf1e4>A</span> 引き込み（作成時にコピーし以後は個別に編集） </span><span class=\"d-inline-flex align-center ga-1\" data-v-157cf1e4><span class=\"tp-legend tp-legend--reference\" data-v-157cf1e4>A</span> 参照（常に上位の値を映す・編集不可） </span><span class=\"d-inline-flex align-center ga-1\" data-v-157cf1e4><span class=\"tp-legend tp-legend--broken\" data-v-157cf1e4>A</span> 要確認 </span></div>", 1)),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, "設定済みのルール（" + _toDisplayString(_ctx.draftRules.length) + "件）", 1),
                      (_ctx.brokenCount > 0)
                        ? (_openBlock(), _createBlock(_component_v_checkbox, {
                            key: 0,
                            modelValue: _ctx.brokenOnly,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.brokenOnly) = $event)),
                            label: "要確認のみ表示",
                            density: "compact",
                            color: "warning",
                            "hide-details": ""
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_spacer),
                      (_ctx.isDirty)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                            _createVNode(_component_v_icon, { size: "14" }, {
                              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                _createTextVNode("mdi-circle-medium", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[18] || (_cache[18] = _createTextVNode(" 未保存の変更があります ", -1))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        variant: "flat",
                        size: "small",
                        loading: _ctx.saving,
                        disabled: !_ctx.isDirty || _ctx.loading || _ctx.loadedTemplateId !== _ctx.targetTemplateId,
                        onClick: _ctx.save
                      }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode(" 保存する ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["loading", "disabled", "onClick"])
                    ]),
                    _createVNode(_component_v_table, {
                      density: "compact",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _cache[24] || (_cache[24] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { style: {"width":"72px"} }, "記号"),
                            _createElementVNode("th", null, "転記元の項目"),
                            _createElementVNode("th", { style: {"width":"110px"} }, "種別"),
                            _createElementVNode("th", null, "転記先の項目"),
                            _createElementVNode("th", { style: {"width":"150px"} }, "状態"),
                            _createElementVNode("th", { style: {"width":"80px"} })
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleRules, (rule) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: rule.targetItemKey,
                              class: _normalizeClass(["tp-rule-row", { 'tp-rule-row--active': _ctx.activeRuleTargetKey === rule.targetItemKey }]),
                              onClick: ($event: any) => (_ctx.focusRule(rule.targetItemKey)),
                              onMouseenter: ($event: any) => (_ctx.hoveredRuleTargetKey = rule.targetItemKey),
                              onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hoveredRuleTargetKey = null))
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["tp-legend", rule.broken
                    ? 'tp-legend--broken'
                    : rule.mode === 'reference'
                      ? 'tp-legend--reference'
                      : 'tp-legend--carry'])
                                }, _toDisplayString(rule.symbol), 3)
                              ]),
                              _createElementVNode("td", null, [
                                _createTextVNode(_toDisplayString(_ctx.sourceCellName(rule.sourceItemKey)) + " ", 1),
                                (_ctx.sourceKeysByTemplate.length > 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.sourceScopeLabel(rule.sourceItemKey)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_chip, {
                                  size: "x-small",
                                  variant: "flat",
                                  color: rule.mode === 'reference' ? 'primary' : 'light-blue-lighten-4'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.transferModeLabels[rule.mode]), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"])
                              ]),
                              _createElementVNode("td", null, [
                                (_ctx.isInTargetLayout(rule.targetItemKey))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.targetCellName(rule.targetItemKey)), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-grey-darken-1" }, "レイアウトにない項目", -1)),
                                      _createElementVNode("div", _hoisted_23, _toDisplayString(rule.targetItemKey), 1)
                                    ], 64))
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_24, [
                                  (rule.broken)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 0,
                                        size: "x-small",
                                        variant: "flat",
                                        color: "warning"
                                      }, {
                                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                          _createTextVNode(" 要確認 ", -1)
                                        ]))]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.missingSourceTemplates(rule.sourceItemKey).length > 0)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 1,
                                        size: "x-small",
                                        variant: "outlined",
                                        color: "warning",
                                        title: _ctx.missingSourceLabel(rule.sourceItemKey)
                                      }, {
                                        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                          _createTextVNode(" 一部から引けません ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["title"]))
                                    : _createCommentVNode("", true),
                                  (!rule.broken && _ctx.missingSourceTemplates(rule.sourceItemKey).length === 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, " — "))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_26, [
                                _createVNode(_component_v_btn, {
                                  size: "x-small",
                                  variant: "text",
                                  color: "error",
                                  onClick: _withModifiers(($event: any) => (_ctx.removeRule(rule.targetItemKey)), ["stop"])
                                }, {
                                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                    _createTextVNode(" 解除 ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ], 42, _hoisted_21))
                          }), 128)),
                          (_ctx.visibleRules.length === 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                                _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.brokenOnly
                    ? "要確認のルールはありません。"
                    : "このレイアウトには転記ルールがありません。"), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }),
                    (_ctx.brokenCount > 0)
                      ? (_openBlock(), _createBlock(_component_v_alert, {
                          key: 0,
                          type: "warning",
                          variant: "tonal",
                          density: "compact",
                          class: "mt-3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.brokenCount) + "件のルールが「要確認」です。転記先の項目がレイアウトから消えたか、種別が変わっています。 ", 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.rulesMissingInSomeSource.length > 0)
                      ? (_openBlock(), _createBlock(_component_v_alert, {
                          key: 1,
                          type: "warning",
                          variant: "tonal",
                          density: "compact",
                          class: "mt-3"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.rulesMissingInSomeSource.length) + "件のルールは、一部の" + _toDisplayString(_ctx.planTypeLabels[_ctx.sourcePlanType]) + "から引けません ", 1),
                            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "text-caption mt-1" }, " 転記元はレイアウトを固定せず項目で指定します。上位の帳票が下記のレイアウトで作られていると、 その項目が無いため転記されません。 ", -1)),
                            _createElementVNode("ul", _hoisted_30, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.missingBySourceTemplate, (entry) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: entry.templateId
                                }, [
                                  _createElementVNode("span", _hoisted_31, _toDisplayString(entry.name), 1),
                                  _createTextVNode(" には " + _toDisplayString(entry.symbols.join("・")) + " の項目がありません（" + _toDisplayString(entry.itemNames.join("・")) + "） ", 1)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
            ], 64))
          : _createCommentVNode("", true)
  ]))
}